<div class="layout">
  @if (permissionService.previewRole(); as preview) {
    <output class="layout__preview-banner">
      <mat-icon class="layout__preview-icon">visibility</mat-icon>
      <span class="layout__preview-text">
        Previewing as <strong>{{ preview.name }}</strong> — UI only, the backend still authorizes you as admin
      </span>
      <button type="button" class="layout__preview-exit" (click)="exitRolePreview()">
        Exit preview
      </button>
    </output>
  }
  <app-month-unlock-banner />
  <app-red-scheduler-claim-banner />
  <div class="layout__topbar">
    <app-topbar (menuToggle)="toggleSidebar()" />
  </div>
  @if (tabViewService.enabled()) {
    <app-tab-bar />
  }
  <div class="layout__body">
    <!-- Compact viewports (phones, portrait tablets): the sidebar is an overlay
         drawer opened from the topbar menu button instead of an inline rail. -->
    @if (viewport.isCompact() && drawerOpen()) {
      <div
        class="layout__drawer-backdrop"
        role="presentation"
        (click)="closeDrawer()"
        (keydown.escape)="closeDrawer()"
      ></div>
    }
    <div
      class="layout__sidebar"
      [class.layout__sidebar--collapsed]="sidebarCollapsed && !viewport.isCompact()"
      [class.layout__sidebar--drawer]="viewport.isCompact()"
      [class.layout__sidebar--drawer-open]="viewport.isCompact() && drawerOpen()"
    >
      <app-sidebar
        [collapsed]="sidebarCollapsed && !viewport.isCompact()"
        (timeseriesPopoutToggle)="toggleTimeseriesPopout()"
        (managedDataPopoutToggle)="toggleManagedDataPopout()"
        (customViewsPopoutToggle)="toggleCustomViewsPopout()"
      />
    </div>
    @if (timeseriesPopoutOpen) {
      <app-timeseries-popout (popoutClose)="timeseriesPopoutOpen = false" />
    }
    @if (managedDataPopoutOpen) {
      <app-managed-data-popout (popoutClose)="managedDataPopoutOpen = false" />
    }
    @if (customViewsPopoutOpen) {
      <app-custom-views-popout (popoutClose)="customViewsPopoutOpen = false" />
    }
    <main #mainRef class="layout__content">
      <router-outlet />
    </main>
     @if(isBlurred){
      <div class="overlay"
        tabindex="0"
        (click)="hidePopout()"
        (keydown.enter)="hidePopout()"
        [ngStyle]="overlayStyle"></div>
      }
  </div>
</div>
